import React, { useState } from 'react';

import {
  AutoModalPriority,
  useAutoModal,
} from '../../../../common/AutoModalProvider';
import useIsPaymentSystemV2Enabled from '../../../PaymentOrder/hooks/useIsPaymentSystemV2Enabled';
import {
  broadcastCreditProductPurchaseComplete,
  CreditProductPurchaseProcessingPayload,
  useListenCreditProductPurchaseProcessing,
} from '../purchaseModalBroadcastChannels';
import { CreditProductPurchaseOrderForAfterPayment } from '../types';
import V2OrderProcessingModal from '../V2OrderProcessingModal/V2OrderProcessingModal';

export default function V2CreditProductPurchaseProcessingHandler() {
  const [processingOrder, setProcessingOrder] =
    useState<CreditProductPurchaseProcessingPayload | null>(null);

  const isPaymentSystemV2Enabled = useIsPaymentSystemV2Enabled();
  const canShow = useAutoModal(
    AutoModalPriority.Transaction,
    isPaymentSystemV2Enabled && Boolean(processingOrder)
  );

  useListenCreditProductPurchaseProcessing(payload => {
    setProcessingOrder(payload);
  });

  const handleCloseProcessingModal = () => {
    setProcessingOrder(null);
  };

  const handleProcessingComplete = (
    creditProductPurchaseOrder: CreditProductPurchaseOrderForAfterPayment
  ) => {
    broadcastCreditProductPurchaseComplete(creditProductPurchaseOrder);
  };

  if (!isPaymentSystemV2Enabled) {
    return null;
  }

  return (
    <>
      {processingOrder && canShow && (
        <V2OrderProcessingModal
          orderNumber={processingOrder.orderNumber}
          jobId={processingOrder.jobId}
          onComplete={handleProcessingComplete}
          onClose={handleCloseProcessingModal}
        />
      )}
    </>
  );
}
